import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './styles/TopBar.module.css';
import CanvasContext from '../../../context/CanvasContext';
import {
    FaEdit,
} from 'react-icons/fa';


const TopBar = ({renderEditSidebar, setRenderEditSidebar, isMobile}) => {

    const { 
        scenario, selectedNodeIds, onCanvasClick,
    } = useContext(CanvasContext);

    const navigate = useNavigate();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    
    const isButtonDisabled = !selectedNodeIds || selectedNodeIds.length < 1;



    useEffect(() => {
        if (isButtonDisabled) {
            setIsDropdownOpen(false);
        }
    }, [isButtonDisabled, isDropdownOpen]);

    const toggleEditSidebar = () => {
        
        if (isMobile && renderEditSidebar) {
            
            setRenderEditSidebar(false);
            onCanvasClick();
        } else {
            
            setRenderEditSidebar(!renderEditSidebar);
        }
    };
    
    return (
        <>
            <div className={styles.container}>
                {/* Left Section */}
                <div className={styles.leftSection}>
                    <div className={styles.logoContainer}>
                        <img
                            className={styles.logo}
                            src={require('../../../images/logo_teal_background.png')}
                            alt="Home"
                            onClick={() => navigate('/home')}
                        />
                    </div>
                </div>
    
                {/* Middle Section */}
                <div className={styles.middleSection}>
                    <div className={styles.titleContainer}>
                        <h1>{scenario?.title || 'Untitled Scenario'}</h1>
                    </div>
                </div>
    
                {/* Right Section */}
                <div className={styles.rightSection}>
                    <div
                        className={`${styles.item} ${renderEditSidebar ? styles.itemActive : ''}`}
                        onClick={toggleEditSidebar}
                        data-tooltip-id="tooltip"
                        data-tooltip-content="Edit Tools"
                    >
                        <FaEdit />
                    </div>
                </div>
            </div>
        </>
    );
    
}

export default TopBar;
